
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
// import { Storage, Configuration, URLFactory, ServiceLocator } from '@c4/core';
import { StorageService } from './storage.service';
import { ConfigurationService } from './configuration.service';
import { UrlFactoryService } from './url-factory.service';
import { ServiceLocatorService } from './service-locator.service';

import { SubState, ISubStore } from '../interfaces/store';
import { IReducer, IReducerArgument } from '../interfaces/reducer';

declare var module: any;

const CONFIG_INITIAL_STATE: SubState = { loaded: false };

export const UPDATE_COMMON_CONFIG: string = 'UPDATE_COMMON_CONFIG';

export function commonConfigReducer(state: SubState = CONFIG_INITIAL_STATE, {type, payload}: IReducerArgument): SubState {
  switch (type) {
    case UPDATE_COMMON_CONFIG:
      console.log('commonConfig.reducer: updating config', payload);
      payload.loaded = true;
      return payload;
  }

  return state;
};

const DEFAULT_ROUTE_NAME: string = 'defaultRouteName';

@Injectable()
export class CommonConfigService {
  commonConfig: Observable<any>;

  constructor(
    private store: Store<any>,
    private http: Http,
    private storage: StorageService,
    private url: UrlFactoryService,
    private serviceLocator: ServiceLocatorService
  ) {
    this.commonConfig = <Observable<any>>this.store.select('commonConfig');
  }

  set defaultRouteName(path: string) {
    this.storage.set(DEFAULT_ROUTE_NAME, path);
  }

  get defaultRouteName(): string {
    return this.storage.get(DEFAULT_ROUTE_NAME);
  }

  get env(): string {
    return this.storage.get('env');
  }
}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/common-config.service.ts